import { Link, styled } from "@mui/material"
import type { MouseEventHandler } from "react"
import { Link as RouterLink } from "react-router"

export const NavLink = ({
  to,
  children,
  onClick,
}: {
  children: React.ReactNode
  to: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}) => {
  const active = false
  return (
    <Link
      to={to}
      component={RouterLink}
      onClick={onClick}
      sx={{
        position: "relative",
        transition: "color 150ms ease-in-out",
        color: active ? "primary.main" : "inherit",
        "&:hover": {
          color: "primary.main",
        },
      }}
    >
      {children}
    </Link>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const navLinkStyle = {
  cursor: "pointer",
  transition: "color 150ms ease-in-out",
  "&:hover": {
    color: "primary.main",
  },
  "&:last-child": {
    marginRight: 0,
  },
}
export const StyledNavLink = styled(NavLink)({
  ...navLinkStyle,
})
